import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../types/results';
import { EOfferType, getPageNumber } from '../../utils/trackings';

interface IAnalyticsProduct {
  id: number;
  offerType: EOfferType;
  position: number;
  published: boolean;
}

export const trackOnlineBookingBookButton = (
  entity: Pick<IFavoriteEntity, 'entityId' | 'status'>,
  position: number,
  offersQty: number,
) => {
  const pageNumber = getPageNumber(offersQty, position);

  const product: IAnalyticsProduct = {
    id: entity.entityId,
    offerType: EOfferType.Offer,
    position,
    published: entity.status === 'published',
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentButton',
    action: 'Click',
    label: 'ToCardCheckDates',
    page: {
      pageType: 'ListingFavorites',
      listingType: 'list',
      pageNumber,
      offersQty,
    },
    products: [product],
  });
};
